import React from 'react';
import PropTypes from 'prop-types';
import styles from '../contents.module.css';
import {setStyles} from 'helpers/setStyles.js';

const level1 = props => (
    <div style={{padding: '56px 0 56px 0', borderBottom: '1px #C4C8CC solid',}}>
        <div style={{ marginBottom: '24px' }}>
            <h1 className={setStyles(styles['h1-level'], styles['h1-level-printable'])}>{props.title}</h1>
        </div>
        {props.children}
    </div>
);

level1.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
};

export default level1;
